<script>
const path = 'https://v-pic.jingjiribao.cn/';//作品上传图片视频拼接地址  
const pc_url = 'https://v.jingjiribao.cn/';//导航地址拼接
const home = 'https://v.jingjiribao.cn/newcommunity/#/activity_index/'
export default
  {
    path,//用户地址
    pc_url,//导航地址拼接
    home
  }
</script>


// WEBPACK FOOTER //
// src/components/url.vue